<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="用户昵称">{{detailObject.name}}</el-descriptions-item>
				<el-descriptions-item label="绑定手机号">{{detailObject.user_phone}}</el-descriptions-item>
				<el-descriptions-item label="反馈类型">{{detailObject.type==1?'机器售后':'用户反馈'}}</el-descriptions-item>
				<el-descriptions-item label="反馈时间">{{detailObject.create_time}}</el-descriptions-item>
			</el-descriptions>
		</el-card>

		<el-card shadow="never" style="margin-top: 20px;">
			<div slot="header" class="clearfix">
				<h4>反馈内容</h4>
			</div>
			<el-descriptions title="" :column="1" border>
				<el-descriptions-item label="问题描述">{{detailObject.content}}</el-descriptions-item>
				<el-descriptions-item label="图片">
					<div class="flex flex-wrap">
						<img v-for="(item,index) in detailObject.img"
							@click="previewImgObj.imgList = detailObject.img,previewImgObj.popup = true,previewImgObj.index=index" :src="item"
							style="width: 120px;height: 120px;border-radius: 5px;margin-right: 10px;" />
					</div>
				</el-descriptions-item>
				<el-descriptions-item label="联系方式">{{detailObject.phone}}</el-descriptions-item>
			</el-descriptions>
		</el-card>


		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" plain @click="goBack">返回</el-button>
		</el-card>

		<PriviewImg :previewImg='previewImgObj'></PriviewImg>
	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import PriviewImg from '../../../components/PriviewImg.vue';
	import {
		getFeedbackDetail
	} from "@/api/marketing"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				previewImgObj: {
					popup: false,
					imgList: [],
					index:0
				}
			};
		},
		components: {
			CommonPagination,
			PriviewImg
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			if (uuid) {
				this.getFeedbackDetail(uuid);
			}
		},
		methods: {
			handlePageChange(page) {
				this.page_index = page
			},
			handlePageChange1(page) {
				this.page_index1 = page
				this.getAiApplicationHistoryList()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getDoubao()
				}
			},
			goBack() {
				this.$router.go(-1)
			},
			async getFeedbackDetail(uuid) {
				const {
					data,
					status
				} = await getFeedbackDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.detailObject = data.result;
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},

		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>